import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Address } from '../../interfaces/location/address.interface';
import { SourceDestinationForm } from '../../interfaces/route-planning/forms/source-destination-form';
import { LocationService } from '../../services/location/location.service';
import { RoutePlanningService } from '../../services/route-planning/route-planning.service';
import { DateTime } from 'src/app/@shared/interfaces/date-time.interface';
import { eDepartureTimeOptions } from '../../constants/departure-time-options.constants';
import { City } from '../../interfaces/location/city.interface';
import { Stop } from '../../interfaces/route-planning/gtfs/stop.interface';
import { eTab } from '../../enums/route-planning/tabs/tabs.enums';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';

export abstract class RoutePlannerFormComponent {
  routePlannerForm: FormGroup;

  constructor(
    public readonly formId: eTab,
    public buttonTitle: string,

    protected readonly fb: FormBuilder,
    protected readonly locationsService: LocationService,
    protected readonly queryParamsService: QueryParamsService,
    protected readonly routePlanningService: RoutePlanningService,
    protected readonly router: Router,
    private readonly utilService: UtilsService,
  ) {
    this.routePlannerForm = fb.group({});

     this.queryParamsService
       ._tabChanged$
       .subscribe(tab => {
         if (tab == this.formId) {
          this.autofillQueryParams()
        }
      });
  }

  public abstract submitRoutePlannerForm();
  public abstract autofillQueryParams();
  public abstract onTabLeave();

  public openAutocomplete(
    formControl: FormControl<any>,
    title: string,
    queryParam: string
  ) {
  }

  switchLocations() {
    const routerPlanningFormValues: SourceDestinationForm =
      this.routePlannerForm.value;

    this.routePlannerForm.patchValue({
      origin: routerPlanningFormValues.destination,
      destination: routerPlanningFormValues.origin,
    });
  }

  getNestedGroup(groupName: string): FormGroup {
    return this.routePlannerForm.get(groupName) as FormGroup;
  }

  getFormControl(formControlName: string): FormControl {
    return this.routePlannerForm.get(formControlName) as FormControl;
  }

}
